import type { Theme } from '@mui/material/styles'

export const inputSx = (theme: Theme) => {
  const isDark = theme.palette.mode === 'dark'
  return {
    mb: 1.5,
    '& .MuiInputLabel-root': {
      fontSize: '0.9375rem',
      color: isDark ? '#FFFFFF99' : '#6E6E73'
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: isDark ? '#FFFFFF' : '#0A0F1C'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      fontSize: '0.9375rem',
      backgroundColor: isDark ? '#1C1C1E' : '#F5F5F7',
      transition:
        'background-color 120ms ease, border-color 120ms ease, box-shadow 120ms ease',
      '& fieldset': {
        borderColor: isDark ? '#2A2A2E' : '#D1D1D6',
        transition: 'border-color 120ms ease'
      },
      '&:hover': {
        backgroundColor: isDark ? '#242427' : '#EFEFF2'
      },
      '&:hover fieldset': {
        borderColor: isDark ? '#36363A' : '#B0B0B5'
      },
      '&.Mui-focused': {
        backgroundColor: isDark ? '#1C1C1E' : '#FFFFFF',
        boxShadow: isDark
          ? '0 0 0 4px rgba(0, 207, 243, 0.18)'
          : '0 0 0 4px rgba(0, 207, 243, 0.15)'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#00CFF3',
        borderWidth: '1px'
      }
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: '14px',
      paddingBottom: '14px'
    }
  }
}

export const primaryButtonSx = (theme: Theme) => {
  const isDark = theme.palette.mode === 'dark'
  return {
    height: 48,
    borderRadius: '12px',
    backgroundColor: isDark ? '#FFFFFF' : '#0A0F1C',
    color: isDark ? '#0A0F1C' : '#FFFFFF',
    textTransform: 'none' as const,
    fontSize: '0.9375rem',
    fontWeight: 700,
    letterSpacing: '-0.005em',
    boxShadow: 'none',
    transition: 'background-color 120ms ease, transform 120ms ease',
    '&:hover': {
      backgroundColor: isDark ? '#F0F0F0' : '#1A1F2E',
      boxShadow: 'none'
    },
    '&:active': {
      transform: 'scale(0.99)'
    },
    '&.Mui-disabled': {
      backgroundColor: isDark ? '#1A1A1D' : '#F2F2F5',
      color: isDark ? '#5A5A5F' : '#B0B0B5'
    }
  }
}

export const secondaryButtonSx = (theme: Theme) => {
  const isDark = theme.palette.mode === 'dark'
  return {
    height: 48,
    borderRadius: '12px',
    backgroundColor: 'transparent',
    color: isDark ? '#FFFFFF' : '#0A0F1C',
    border: `1px solid ${isDark ? '#2A2A2E' : '#D1D1D6'}`,
    textTransform: 'none' as const,
    fontSize: '0.9375rem',
    fontWeight: 600,
    letterSpacing: '-0.005em',
    boxShadow: 'none',
    transition: 'background-color 120ms ease, border-color 120ms ease',
    '&:hover': {
      backgroundColor: isDark ? '#1C1C1E' : '#F5F5F7',
      borderColor: isDark ? '#36363A' : '#B0B0B5',
      boxShadow: 'none'
    }
  }
}

export const destructiveButtonSx = () => ({
  height: 48,
  borderRadius: '12px',
  backgroundColor: '#FF453A',
  color: '#FFFFFF',
  textTransform: 'none' as const,
  fontSize: '0.9375rem',
  fontWeight: 700,
  letterSpacing: '-0.005em',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#E03B31',
    boxShadow: 'none'
  }
})
